
import PropTypes from 'prop-types'
import { createOnFilter } from 'filter'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import MuiFormSelect from 'frame/components/mui-form-select'

const FilterAttributes = ({ filters, filtered, onFilter }) => {
  const hasList = (list) => list && list.length > 0
  const { costCentres, controllers, fleetControllers } = filters
  const controllerOptions = controllers || fleetControllers || []

  const onSelect = createOnFilter(onFilter)

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          paddingY: 1,
          paddingX: 0,
          cursor: 'pointer',
        }}>
        <Typography variant="h5">Filters</Typography>
      </Box>
      <Divider />
      <Stack gap={2} py={2}>
        {hasList(costCentres) && (
          <MuiFormSelect
            id="costCentre"
            label="Cost Centre"
            options={costCentres}
            value={filtered.costCentre}
            onChange={onSelect('costCentre')}
            includeEmptyOption />
        )}
        {hasList(controllerOptions) && (
          <MuiFormSelect
            id="controller"
            label="Controller"
            options={controllerOptions}
            value={filtered.fleetController}
            onChange={onSelect('fleetController')}
            includeEmptyOption />
        )}
      </Stack>
    </Box>
  )
}

FilterAttributes.propTypes = {
  filters: PropTypes.object.isRequired,
  filtered: PropTypes.object.isRequired,
  onFilter: PropTypes.func.isRequired,
}

export default FilterAttributes
